var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "receipt"
  }, [_c('top'), _vm._v(" "), _c('div', {
    staticClass: "receipt-content"
  }, [_c('div', {
    staticClass: "hot-question"
  }, [_c('div', {
    staticClass: "hot-top-content"
  }, [_c('div', {
    staticClass: "hot-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.questionName))])])]), _vm._v(" "), _c('div', {
    staticClass: "hot-btm-content"
  }, _vm._l((_vm.accountList), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "hot-item-content"
    }, [_c('div', {
      staticClass: "hot-item",
      on: {
        "click": function($event) {
          _vm.itemClick(item)
        }
      }
    }, [_c('img', {
      staticClass: "img-icon",
      attrs: {
        "src": require("../../assets/receipt-item-icon.png"),
        "alt": ""
      }
    }), _c('span', [_vm._v(_vm._s(item.questionName))]), _c('img', {
      staticClass: "img-icon item-right",
      attrs: {
        "src": require("../../assets/receipt-item-right.png"),
        "alt": ""
      }
    })])])
  }))])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4cdef5c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/question/receipt.vue
// module id = c+ye
// module chunks = 1